/*
 * @Description: 银行
 * @Date: 2025-03-03 11:38:40
 */
import { IS_ASSISTANT } from '@/config';

/**
 * 开通渠道：zbBank：众邦银行，fyBank：富友支付，offLineBank：网银支付
 * FIXME: 账户只用了富友，引用此处并解构出来的。
 */
export const PAY_PASSAGEWAY_MAPPING = {
  zbBank: {
    value: 'zbBank',
    label: '众邦银行',
    key: 'zb'
  },
  fyBank: {
    value: 'fyBank',
    label: '富友支付',
    key: 'fy'
  },
  offLineBank: {
    value: 'offLineBank',
    label: '网银支付',
    key: 'offLine'
  },
  ...(IS_ASSISTANT
    ? {
        jhBank: {
          value: 'jhBank',
          label: '聚合支付',
          key: 'jh'
        }
      }
    : {})
};

export const DITHDRAWAL_STATUS = {
  0: { label: '未提现', value: 0 },
  1: { label: '提现中', value: 1 },
  2: { label: '已提现', value: 2 },
  3: { label: '提现失败', value: 3 }
};
export const IN_TYPE = {
  1: { label: '项目收入', value: 1 },
  2: { label: '充值', value: 2 },
  3: { label: '综合附加扣除收入', value: 3 },
  5: { label: '个体项目费用收入', value: 5 },
  6: { label: '提现退回', value: 6 }
};
export const OUT_TYPE = {
  1: { label: '项目支出', value: 1 },
  2: { label: '提现', value: 2 },
  3: { label: '提现手续费', value: 3 },
  4: { label: '综合附加扣除支出', value: 4 },
  5: { label: '个体项目费用支出', value: 5 }
};
export const INOUT_TYPE = {
  1: { label: '收入', value: 1, option: IN_TYPE },
  2: { label: '支出', value: 2, option: OUT_TYPE }
};
export const AUTH_STATUS = {
  0: { label: '未开通', value: 0 },
  1: { label: '平台审核中', value: 1 },
  2: { label: '平台审核失败', value: 2 },
  3: { label: '平台审核通过', value: 3 },
  4: { label: '银行审核中', value: 4 },
  5: { label: '银行审核失败', value: 5 },
  6: { label: '银行通过', value: 6 },
  7: { label: '已关闭', value: 7 }
};
// C端收款方式
export const C_PAYMENT_METHOD = {
  1: { label: '银行卡', value: 1 },
  2: { label: '钱包', value: 2 }
};
export const CASH_OUT_TYPE = {
  1: { label: '手动提现', value: 1 },
  2: { label: '自动提现', value: 2 }
};
export const OPEN_STATUS = {
  [-1]: { label: '停用', value: -1 },
  0: { label: '未开通', value: 0 },
  1: { label: '开通中', value: 1 },
  2: { label: '已开通', value: 2 },
  3: { label: '开通失败', value: 3 }
};
